var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightIconErrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6674 6.21259C10.4079 6.20778 10.1533 6.28375 9.93884 6.42999C9.72439 6.57623 9.56069 6.78551 9.47041 7.02887C9.38012 7.27223 9.36771 7.53763 9.43488 7.78835C9.50206 8.03908 9.6455 8.26272 9.84536 8.42834L17.4942 14.9764L9.84064 21.5244C9.70081 21.6263 9.58364 21.7561 9.4965 21.9056C9.40937 22.0551 9.35417 22.2211 9.33438 22.393C9.3146 22.5648 9.33066 22.739 9.38156 22.9044C9.43245 23.0697 9.51708 23.2228 9.63009 23.3538C9.7431 23.4848 9.88205 23.591 10.0382 23.6656C10.1943 23.7403 10.3642 23.7817 10.5371 23.7874C10.71 23.7931 10.8823 23.7628 11.0429 23.6986C11.2036 23.6344 11.3492 23.5375 11.4706 23.4142L20.2202 15.9354C20.3578 15.8179 20.4683 15.6719 20.544 15.5076C20.6198 15.3432 20.659 15.1644 20.659 14.9835C20.659 14.8025 20.6198 14.6237 20.544 14.4593C20.4683 14.295 20.3578 14.149 20.2202 14.0315L11.4706 6.52913C11.2488 6.33174 10.9642 6.21955 10.6674 6.21259Z",
    fill: "#565656"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightIconErrow);
export default __webpack_public_path__ + "static/media/right-icon-errow.95f0023e718ec3dd3b92d73a96162e55.svg";
export { ForwardRef as ReactComponent };